import App from "App";
import {
  AuthContextProvider,
  MaterialUIControllerProvider,
} from "contexts/auth.context";
import LanguageContextProvider from "contexts/language.context";
import LoadingContextProvider from "contexts/loading.context";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

import "./index.css";

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <LanguageContextProvider>
        <AuthContextProvider>
          <LoadingContextProvider>
            <App />
          </LoadingContextProvider>
        </AuthContextProvider>
      </LanguageContextProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
